import { JobSiteModel } from "../customer/job-site-detail-model";

export class AgreementVisitModel {
    ID: string;
    ServiceTypeID: string;
    ProposedDate: string;
    FollowupDate: string;
    DispatchComment: string;
    WorkTicketID: string;
    IsAdhoc: boolean;
    WoNumber: string;
    PromisedDate: string;
    ServiceType: string;
    Status: string;
    AttemptCount: number;

    constructor(isAdhoc = true) {
        this.ID = "";
        this.ServiceTypeID = "";
        this.WorkTicketID = "";
        this.ProposedDate = "";
        this.FollowupDate = "";
        this.DispatchComment = "";
        this.WorkTicketID = "";
        this.IsAdhoc = isAdhoc;
        this.WoNumber = "";
        this.PromisedDate = "";
        this.ServiceType = "";
        this.Status = "";
        this.AttemptCount = 0;
    }
}

export interface VisitModel {
    ID: string;
    JobSite: JobSiteModel;
    ProposedDate: string;
    PromisedDate: string;
    DispatchComment:string;
    CallReasons: CallReasonModel[];
    Postponements: PostponementModel[];
    NextTicket: any;
    AgreementNumber: string;
    AttemptCount: number;
    FollowupDate: string;
    ServiceAgreementID: string;
    ModifiedDate: string
}

export interface PostponementModel {
    PostponedByUser?: {
        FirstName: string;
        LastName: string;
    };
    PostponementNote: string;
    OldDate?: string;
    CreatedDate?: string;
    PostponedDate: string;
    ModifiedDate: string;
}

export interface CallReasonModel {
    ID: string;
    Name: string;
    Category: string;
    SkillLevel: number;
    EstimatedTime: string;
    Quantity: number;
}

export type VisitEmitType = 'Status' | 'FollowupDate';
